import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout'
import TestimonialSection1 from './TestimonialSection1'
import Footer from '../../Layout/Footer'
import TestimonialAdmin from './TestimonialAdmin'
import FooterCalendar from '../../Layout/FooterCalendar'
import FooterNew from '../../Layout/FooterNew'
import SEO from '../../SEO'
import axios from 'axios'
const BASE_URL = "https://ecom.cyberathon.com/index.php/Api"; 
function Testimonial() {
  const [seoData, setSeoData] = useState({});
useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/get_seo_by_page`, { page_name: 'testimonial' });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  return (
    <>
    <SEO
    title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
    description={seoData.description || "ShopIndia is the best online shopping platform..."}
    keywords={seoData.keywords || "ShopIndia, online shopping, electronics, clothes, medicines"}
    canonical={seoData.canonical || "https://www.shopindia.com/"}
  />
    <Layout/>
    {/* <TestimonialSection1/> realone */}
    <TestimonialAdmin/>
    {/* <Footer/> */}
    {/* <FooterCalendar/> */}
    <FooterNew/>
    </>
  )
}

export default Testimonial
